import { triggerListUpdate, isImporting } from '$lib/stores/trigger_list_update';
import { get } from 'svelte/store';
import { user } from '$lib/stores/auth';
import type { ImageType, Role } from '@briefmarken_katalog/types';

let eventSource: EventSource | null = null;

type UploadCallback = (sessionToken: string, picture: ImageType) => void;
const uploadCallbacks = new Set<UploadCallback>();

export function connectSse(): void {
    if (eventSource) return;

    eventSource = new EventSource('/api/events');

    eventSource.addEventListener('catalog:updated', () => {
        if (!get(isImporting)) triggerListUpdate();
    });

    eventSource.addEventListener('user:updated', (e: MessageEvent) => {
        const data: { id: string; email?: string; name?: string; role?: Role } = JSON.parse(e.data);
        const current = get(user);
        if (current && data.id === current.id) {
            user.update(u => u ? { ...u, ...data } : u);
        }
    });

    eventSource.addEventListener('upload:picture_ready', (e: MessageEvent) => {
        const data = JSON.parse(e.data);
        for (const cb of uploadCallbacks) cb(data.sessionToken, data.picture);
    });

    eventSource.onerror = () => {
        // EventSource auto-reconnects with back-off; nothing extra needed
    };
}

export function subscribeUploadPictureReady(cb: UploadCallback): () => void {
    uploadCallbacks.add(cb);
    return () => uploadCallbacks.delete(cb);
}

export function disconnectSse(): void {
    eventSource?.close();
    eventSource = null;
}
